import { Helmet } from 'react-helmet-async';
import ClinicTelehealthsView from 'src/sections/clinic-dashboard/therapies/therapy-view';
// sections

// ----------------------------------------------------------------------

export default function ClinicTelehealthsPage() {
  return (
    <>
      <Helmet>
        <title>Clinic Telehealths</title>
      </Helmet>

      <ClinicTelehealthsView />
    </>
  );
}
